<template>
  <div class="wrap">
    <van-sticky>
      <van-nav-bar title="修改登录密码" left-arrow @click-left="$router.go(-1)"/>
    </van-sticky>
    <van-cell-group>
      <van-field label="旧密码" v-model="form.old_password" placeholder="请输入登录密码" type="password"></van-field>
      <van-field label="新密码" v-model="form.password" placeholder="请输入登录密码" type="password"></van-field>
      <van-field label="确认新密码" v-model="form.password_re" placeholder="请确认登录密码" type="password"></van-field>
    </van-cell-group>
    <div class="set-but" @click="submitReg">保存</div>
  </div>
</template>

<script>
import { sendSms } from "@/api/login";
import { updateLoginPassword } from "@/api/personal";

export default {
  data() {
    return {
      disabled: true,
      codetext: "验证码",
      value: "",
      readonly: false,
      form: {
        old_password: "",
        password: "",
        password_re: ""
      }
    };
  },
  created() {
    this.form.phone = localStorage.getItem("userPhone");
  },
  methods: {
    send() {
      sendSms({ phone: this.form.phone }).then(res => {
        this.countDown(60);
      });
    },
    countDown(time) {
      if (time === 0) {
        this.disabled = true;
        this.codetext = "获取";
        return;
      } else {
        this.disabled = false;
        this.codetext = "重新发送(" + time + ")";
        time--;
      }
      setTimeout(() => {
        this.countDown(time);
      }, 1000);
    },
    submitReg() {
      if (!this.form.old_password || !this.form.password || !this.form.password_re) {
        this.$toast("请填写完整信息!");
        return;
      }
      updateLoginPassword(this.form).then(res => {
        this.$router.push("login");
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.top {
  width: 100%;
  text-align: center;
  img {
    width: 85px;
    margin: 10px auto;
  }
}
.wrap {
  position: relative;
  background-size: 100% 100%;
  left: 0;
  width: 100%;
  height: 100vh;
  text-align: center;
  font-size: 15px;
}
.van-cell-group {
  margin: 0 auto 42px;
  background: transparent;
  .van-cell {
    background-color: transparent;
    display: flex;
    align-items: center;
  }
}
.phoneIcon {
  height: 100%;
  display: inline-block;
  vertical-align: middle;
  width: 18px;
  margin-right: 6px;
}
.codeIcon {
  width: 20px;
  height: 23px;
}
.inviteIcon {
  width: 19.5px;
  height: 24px;
}
.psdIcon {
  width: 18px;
  height: 21px;
}
.set-but {
  display: block;
  width: 345px;
  display: block;
  height: 35px;
  background: #3B6BFB;
  font-size: 18px;
  margin: 0 auto;
  border-radius: 17.5px;
  color: #fff;
  text-align: center;
  line-height: 35px;
}
.van-button--primary {
  background: rgba(255, 108, 26, 1);
  border: none;
  border-radius: 15px;
  color: white;
  padding:10px 20px;
}
</style>
